import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import Modal from "@acadia-ui/modal";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import { useCallback, useMemo } from "react";
import { retryAtInterval } from "./retryAtInterval";
import TableHelper from "../../../Components/Table/TableHelper";
import DuplicatePlatformModal from "../../Modals/DuplicatePlatformModal";
import { TOOLBAR_MODE } from "@acadia-ui/toolbar";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";
import { draftHLISelected } from "../../../Helpers/ActionHelpers";

export default function useDuplicate({ config, selectedRows, renderedData, dataTableApi }) {
	const handleDuplicate = (dataWithDuplicates, totalCount) => {
		showToast(
			"workbookToasts",
			<ToastNotification
				type={TOAST_TYPE.SUCCESS}
				message="Placements have been successfully created in bulk. You need to fill out dimension fields in table."
				timed={10000}
			/>
		);

		dataTableApi.current.dataProvider.update(dataWithDuplicates);
		// Defer until after DataProvider's async get() call updates filteredData,
		// which is the data source used for cell-state index computation.
		setTimeout(() => {
			dataTableApi.current.refreshDisabledCellStates?.();
		}, 100);
		retryAtInterval(
			() => {
				dataTableApi?.current?.toolbarApi?.current?.changeActiveMode?.(TOOLBAR_MODE.EDIT);
			},
			() => dataTableApi?.current?.toolbarApi?.current?.activeMode === TOOLBAR_MODE.EDIT
		);
		setTimeout(() => {
			for (let i = 0; i < totalCount; i++) {
				const row = dataWithDuplicates[i];
				TableHelper.highlightCell("Placement", row.UniqueID, "Dimensions");
			}
		}, 3000);
	};

	const Trigger = useCallback(() => {
		return (
			<Tooltip key="action-clone" title="Clone Placements" position={TOOLTIP_POSITION.BOTTOM_START}>
				<Button
					size={BUTTON_SIZE.SMALL}
					display={BUTTON_DISPLAY.ICON_BORDERED}
					icon="icon-copy"
					onClick={() => {
						Modal.show("Placement_clone_modal");
					}}
					disabled={draftHLISelected(dataTableApi)}
					data-tracking-id-alt="open-clone-placements-modal"
				>
					Clone
				</Button>
			</Tooltip>
		);
	}, [dataTableApi]);

	const DisplayedComponent = useCallback(() => {
		return (
			<DuplicatePlatformModal
				// this comment exists to prevent eslint from making this unreadable.
				config={config}
				type="Placement"
				data={selectedRows}
				handleDuplicate={handleDuplicate}
				allRows={dataTableApi?.current?.dataProvider?.data || renderedData}
			/>
		);
	}, [renderedData, selectedRows, config, handleDuplicate, dataTableApi]);

	return useMemo(() => [Trigger, DisplayedComponent], [Trigger, DisplayedComponent]);
}
